import React from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import { ReactComponent as PageBackIcon } from '@assets/svg/page-back-icon.svg';

import useTranslation from '@hooks/useTranslation';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import ChatComponent from '../ChatComponent/ChatComponent';
import LocationSelect from './components/LocationSelect/LocationSelect';
import style from './style.module.scss';

interface IProps {
  title: string;
  showLogo?: boolean;
  showFacilitySelect?: boolean;
  isSecondaryPage?: boolean;
  headerLeftComponent?: React.ReactElement;
  headerRightComponent?: React.ReactElement;
  extraInfo?: React.ReactElement;
  locationType?: string;
}

const Header: React.FC<IProps> = ({
  title = '',
  showLogo = false,
  showFacilitySelect = false,
  isSecondaryPage = false,
  headerLeftComponent,
  headerRightComponent,
  extraInfo,
  locationType = '',
}) => {
  const { t } = useTranslation();
  const { customerId } = useParams();
  const navigate = useNavigate();
  const { key } = useLocation();

  const handleBackButton = () => {
    if (key === 'default') {
      navigate('/');
    } else {
      navigate(-1);
    }
  };

  const { data: profileData } = useUserProfileQuery();

  return (
    <header>
      <div className={style.mainHeader}>
        <div className={style.headerLeft}>
          {isSecondaryPage && <PageBackIcon className={style.backIcon} onClick={() => handleBackButton()} />}
          <div className={style.headerTitle}>{title}</div>

          <div className={style.headerLeftInfo}>
            {showLogo && (
              <Link className={style.logoLink} to={`/customer/${customerId}`}>
                <img className={style.logoImg} src={profileData?.customer.header_image} alt="logo" />
              </Link>
            )}
            {showLogo && showFacilitySelect && <span className={style.separator} />}
            {showFacilitySelect && <LocationSelect type={locationType} />}
          </div>
          {headerLeftComponent}
        </div>
        <div className={style.headerRight}>
          {headerRightComponent}
          {!!profileData?.customer?.has_ai_assistant && <ChatComponent />}
        </div>
      </div>
      {!!extraInfo && <div className={style.extraBlock}>{extraInfo}</div>}
    </header>
  );
};

export default Header;
